import { BrowserRouter, Routes, Route } from "react-router-dom";

import NavbarDemo from "./components/navbar";
import About from "./pages/About";
import Institute from "./pages/Institute";
import CourseDetail from "./pages/courses/CourseDetail";
import Technology from "./pages/Technology";
import TechnologyDetail from "./pages/technology/TechnologyDetail";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import ScrollToTop from "./components/ScrollToTop";
import Blog from "./pages/Blog";
import InstituteCareerBlog from "./pages/blog/InstituteCareerBlog";
import SoftwareCompanyBlog from "./pages/blog/SoftwareCompanyBlog";
import DigitalMarketingBlog from "./pages/blog/DigitalMarketingBlog";
import WebDevelopment from "./pages/blog/WebDevelopment";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <NavbarDemo />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/institute" element={<Institute />} />
        <Route path="/institute/:courseSlug" element={<CourseDetail />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/technology/:serviceSlug" element={<TechnologyDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route
          path="/blog/which-course-is-best-for-it-jobs-in-2027"
          element={<InstituteCareerBlog />}
        />
        <Route
          path="/blog/how-to-choose-the-right-software-company-for-your-business"
          element={<SoftwareCompanyBlog />}
        />
        <Route
          path="/blog/what-are-the-benefits-of-a-digital-marketing-course"
          element={<DigitalMarketingBlog />}
        />
        <Route
          path="/blog/6-benefits-of-choosing-a-local-web-development-company"
          element={<WebDevelopment />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
